import { render } from "./Trades.vue?vue&type=template&id=d5653f76&scoped=true"
import script from "./Trades.vue?vue&type=script&lang=js"
export * from "./Trades.vue?vue&type=script&lang=js"

import "./Trades.vue?vue&type=style&index=0&id=d5653f76&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5653f76"]])

export default __exports__